import React, { TextareaHTMLAttributes } from 'react';
import clsx from 'clsx';
import InputLabel from '../atoms/InputLabel';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: string;
  label?: string;
  textColor?: string;
  className?: string;
};

const Textarea = ({
  error,
  label,
  textColor = 'text-white',
  className,
  ...rest
}: TextareaProps) => (
  <div className="w-full grid gap-[20px]">
    {label && <InputLabel name={rest.name}>{label}</InputLabel>}
    <div className="flex flex-col">
      <textarea
        className={clsx(
          'w-full border px-[18px] py-[12px] font-normal leading-none text-base 3xl:text-sm 4xl:text-[15px] placeholder:text-white/40 focus:border-white/40 focus:outline-none transition bg-transparent min-h-[100px]',
          error ? 'border-orange-400' : 'border-white',
          textColor,
          className
        )}
        {...rest}
      />
      {error && <span className="ml-auto text-sm text-orange-400">{error}</span>}
    </div>
  </div>
);

export default Textarea;
